/**
 * Keycloak / OpenID Connect configuration.
 * Uses env vars from .env (see .env.example).
 */
const keycloakUrl: string= process.env.REACT_APP_KEYCLOAK_URL || ''; 
const realm: string= process.env.REACT_APP_KEYCLOAK_REALM || '';
const clientId: string= process.env.REACT_APP_KEYCLOAK_CLIENT_ID || '';
const idpHint: string= process.env.REACT_APP_KEYCLOAK_IDP_HINT || '';

// When set (e.g. for staging), Keycloak redirects here after login; must match backend/Keycloak client config.
const redirectUriOverride: string= process.env.REACT_APP_AUTH_REDIRECT_URI || '';

export const authConfig = {
  keycloakUrl,
  realm,
  clientId,
  idpHint,
  authEndpoint: `${keycloakUrl}/realms/${realm}/protocol/openid-connect/auth`,
  tokenEndpoint: `${keycloakUrl}/realms/${realm}/protocol/openid-connect/token`,
  getRedirectUri: () =>
    redirectUriOverride || `${window.location.origin}/auth/callback`,
} as const;
